import * as angular from "angular";
import * as _ from "lodash";
import { HouseOccupantService } from "../services/house-occupant.service";
import { Field } from "./field.model";
import { House } from "./house.model";
import { CustomFieldAttachmentModel } from "./custom-field-attachment.model";

export class HouseOccupant {
    public readonly requestIgnoreList = ["$filter"];

    public hovolunteer: number | undefined;
    public hodeceased: number | undefined;
    public hodonor: number | undefined;
    public campaignid: number | undefined;
    public hoid: string | undefined;
    public hlastmodifieddatetime: any;
    public consentTypes: any;

    public hofname: string | undefined;
    public holname: string | undefined;
    public hoemail: string | undefined;
    public hohomephone: string | undefined;
    public homobilephone: string | undefined;
    public houseoccupantid: number | undefined;

    public house?: House;
    public cssid?: any;
    public cssname?: any;
    public csreception?: any;
    public cscreationdatetime?: any;
    public cstype?: string;
    public csscolor?: any;
    public user?: any;
    public relevance?: any;
    public honbid?: any;
    public customfields?: any;
    public elections?: any;
    public hovoterid?: any;
    public hoybirthday?: any;
    public hombirthday?: any;
    public hodbirthday?: any;
    public hodob?: any;
    public esid?: any;
    public esname?: any;
    public holastmodifieddatetime?: any;
    public contactmethods?: any;
    public deleted?: boolean;
    public allowedEmail?: boolean;
    public selected_contactmethods?: any;

    public income?: number;
    public credit_rating?: string | undefined;
    public donor_environment?: number | undefined;
    public unique_id?: number | undefined;

    public resource: HouseOccupantService;
    public $q: any;
    public __env: any;
    public $filter: any;

    constructor(
        HouseOccupantService: HouseOccupantService,
        $q: any,
        __env: any,
        $filter: any,
        data?: object
    ) {
        this.$q = $q;
        this.__env = __env;
        this.$filter = $filter;
        this.resource = HouseOccupantService;

        if (data) {
            this.hovolunteer = 0;
            this.hodeceased = 0;
            this.hodonor = 0;
            this.setData(data);
        }
    }

    getID(): string | undefined {
        return this.hoid;
    }

    setData(data?: any): void {
        if (data && data.customfields) {
            let customfields = [];
            angular.forEach(data.customfields, (field: Field) => {
                if (field.cfid) {
                    if (field.cftid == 7 && field.files && field.files.length) {
                        let files = [];
                        angular.forEach(field.files, (file) => {
                            files.push(new CustomFieldAttachmentModel(file));
                        });
                        field.files = files;
                        angular.forEach(
                            this.customfields,
                            (customField: Field) => {
                                if (field.cfid == customField.cfid) {
                                    customField.files = files;
                                }
                            }
                        );
                    }
                    customfields.push(field);
                }
            });
            data.customfields = this.$filter("orderBy")(customfields, "cfid");
        }

        _.merge(this, data);
        if (data.income) this.income = parseInt(data.income);
    }

    identifier(): string {
        if (
            (this.hofname && this.hofname != "") ||
            (this.holname && this.holname != "")
        ) {
            return this.hofname + " " + this.holname;
        } else if (this.hoemail && this.hoemail != "") {
            return this.hoemail;
        } else if (this.hohomephone && this.hohomephone != "") {
            return this.hohomephone;
        } else if (this.homobilephone && this.homobilephone != "") {
            return this.homobilephone;
        } else {
            return (
                "Unknown " +
                this.$filter("capitalize")(this.__env.strings.voter)
            );
        }
    }

    update(): Promise<any> {
        const deferred = this.$q.defer();
        this.resource.update(this).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    angular.extend(this, json.data);
                    deferred.resolve(this);
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }
}
